<template>
    <div class="common-layout">
        <el-container>
            <el-header class="head_lay">
                <WebHeader></WebHeader>
            </el-header>
            <el-main class="main_lay">
                <router-view :key="$route.fullPath" />
            </el-main>
            <el-footer class="footer_lay">
                <WebFooter></WebFooter>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import WebHeader from "@/components/WebHeader.vue";
import WebFooter from "@/components/WebFooter.vue";
export default {
    name: "PageLayout",
    components:{
        WebHeader,
        WebFooter
    }
}
</script>

<style scoped>
  /* 直接引入外部 CSS */
@import "@/assets/css/layout_combined.css";
</style>
